"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.novasolPopularFeatureIds = exports.cottagesPopularFeatureIds = exports.hoseasonsPopularFeatureIds = void 0;
exports.hoseasonsPopularFeatureIds = [
    '10091',
    '6392',
    '6464',
    '9153',
    '9244',
    '6455',
    '9161',
    '6948',
    '2562',
    '9857',
    '3084',
    '3070',
    '3032',
    '3050',
];
exports.cottagesPopularFeatureIds = exports.hoseasonsPopularFeatureIds;
exports.novasolPopularFeatureIds = [
    'FILT-1',
    'FILT-3',
    'FILT-4',
    'FILT-5',
    'FILT-31',
    'FILT-9',
    'FILT-10',
    'FILT-27',
    'FILT-7',
    'FILT-13',
];
//# sourceMappingURL=popularFeatures.js.map